import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
var IpExclusionComponent = /** @class */ (function () {
    function IpExclusionComponent(fb) {
        this.fb = fb;
    }
    IpExclusionComponent.prototype.ngOnInit = function () {
        this.formGroup.addControl('ipExclusionEnabled', this.fb.control(this.globalSettings.ipExclusionEnabled));
        this.formGroup.addControl('blockedIps', this.prepareBlockedIps());
    };
    IpExclusionComponent.prototype.prepareBlockedIps = function () {
        return this.globalSettings.blockedIps && this.globalSettings.blockedIps.length
            ? this.fb.array(this.globalSettings.blockedIps.map(function (ipObject) { return new FormControl(ipObject); }).slice())
            : this.fb.array([this.prepareNewInputField()]);
    };
    IpExclusionComponent.prototype.prepareNewInputField = function () {
        return new FormControl('');
    };
    IpExclusionComponent.prototype.addNewInputField = function () {
        var control = this.formGroup.controls.blockedIps;
        control.push(this.prepareNewInputField());
    };
    IpExclusionComponent.prototype.removeInputField = function (i) {
        var control = this.formGroup.controls.blockedIps;
        control.removeAt(i);
    };
    Object.defineProperty(IpExclusionComponent.prototype, "isIpExclusionEnabled", {
        get: function () {
            return this.formGroup.get('ipExclusionEnabled').value;
        },
        enumerable: true,
        configurable: true
    });
    return IpExclusionComponent;
}());
export { IpExclusionComponent };
